import type { NavigationState, StateDefinition, StateRecord } from "./state.types.js";
import { type ObjectToEntries } from "../lib/utils.js";

/**
 *
 *
 *
 *
 *
 *
 */
export const stateParams = <T extends StateRecord>(state: T = {} as T): NavigationState<T> => {
  const raw = new Map<keyof T, unknown>(Object.entries(state as StateRecord));

  const res: NavigationState<T> = {
    get [Symbol.toStringTag]() {
      return `NavigationState`;
    },
    get empty() {
      return raw.size === 0;
    },
    [Symbol.iterator]: raw[Symbol.iterator].bind(raw) as never,
    clear: raw.clear.bind(raw) as never,
    has: raw.has.bind(raw) as never,
    get: (...a: [string, unknown?]) => {
      const resVal = raw.has(a[0]) ? raw.get(a[0]) : undefined;
      return (resVal === undefined ? a[1] : resVal) as never;
    },
    set: raw.set.bind(raw) as never,
    delete: raw.delete.bind(raw) as never,
    values: raw.values.bind(raw) as never,
    keys: raw.keys.bind(raw) as never,
    forEach: raw.forEach.bind(raw) as never,
    entries: raw.entries.bind(raw) as never,
    /*                       */

    toEntries: () => [...raw] as ObjectToEntries<T>,
    fromEntries(entries) {
      raw.clear();
      for (const [key, value] of entries) raw.set(key, value);
    },

    /*                                */
    toObject: () => Object.fromEntries([...raw]) as never,
    fromObject(data) {
      raw.clear();
      for (const [key, value] of Object.entries(data)) raw.set(key, value);
    },
    clone: () => stateParams(res.toObject()),

    /*              */
    setMany(partial: Partial<T>) {
      for (const [key, value] of Object.entries(partial)) raw.set(key, value);
    },

    /*                  */
    parse: (schema, params) => schema.parse(res.toObject(), params),
    parseSafe: (schema, params) => schema.safeParse(res.toObject(), params),
  };

  return res;
};

/**
 *
 *
 *
 *
 *
 */
export const stateMap = <S extends StateRecord>(): StateDefinition<S> => ({}) as never;
